import { useSyncExternalStore } from 'react';
import { impersonationService } from '@/services/impersonation.service';
import { type ImpersonationSession } from '@/types';

export const useImpersonation = (): ImpersonationSession => {
  return useSyncExternalStore(
    (listener) => impersonationService.subscribe({ listener }),
    impersonationService.getSession,
    impersonationService.getSession
  );
};
